<template>
  <v-card>
    <ValidationObserver
      ref="form"
      tag="form"
      @submit.prevent="storeSettings"
    >
      <v-card-text>
        <ValidationProvider
          vid="company_header"
          :name="$t('fields.company_header').toLowerCase()"
          v-slot="{ errors }"
        >
          <v-textarea
            v-model=" form.company_header"
            :error-messages="errors"
            :label="$t('fields.company_header')"
          ></v-textarea>
        </ValidationProvider>
        <ValidationProvider
          vid="logo"
          :name="$t('fields.logo').toLowerCase()"
          v-slot="{ errors }"
        >
        <v-file-input
          v-model="form.company_logo"
          label="Logo azienda"
          >
        </v-file-input>
      </ValidationProvider>
      <ValidationProvider
          vid="company_logo_secondary"
          v-slot="{ errors }"
        >
        <v-file-input
          v-model="form.company_logo_secondary_file"
          :error-messages="errors"
          label="Logo secondario (opzionale)"
          >
        </v-file-input>
      </ValidationProvider>
      <ValidationProvider
          vid="bullettin_css"
          :name="$t('fields.bullettin_css').toLowerCase()"
          v-slot="{ errors }"
        >
          <v-textarea
            v-model=" form.bullettin_css"
            :error-messages="errors"
            :label="$t('fields.bullettin_css')"
          ></v-textarea>
        </ValidationProvider>
      </v-card-text>
      <v-card-actions>
        <v-btn
          type="submit"
          :loading="loading"
          :disabled="loading"
          color="primary"
        >
          {{ $t('SAVE') }}
        </v-btn>
      </v-card-actions>
    </ValidationObserver>
  </v-card>
</template>

<script>
  import { mapActions } from 'vuex';

  import { settingsService } from '../../utils/services/settings.service';

  export default {
    name: 'AppSettings',
    data() {
      return {
        loading: false,
        form: {
          company_header: null,
          company_logo: null,
          company_logo_secondary: null,
          company_logo_secondary_file: null,
          bullettin_css: '',
        },
      };
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      async storeSettings() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
          this.loading = true;
          const data = new FormData();

          if (this.form.company_header) {
            data.append('company_header', this.form.company_header);
          }

          if (this.form.company_logo) {
            data.append('company_logo', this.form.company_logo);
          }

          if (this.form.company_logo_secondary_file) {
            data.append('company_logo_secondary', this.form.company_logo_secondary_file);
          }

          if (this.form.bullettin_css) {
            data.append('bullettin_css', this.form.bullettin_css);
          }

          const config = {
            header: {
              'Content-Type': 'multipart/form-data',
            },
          };

          settingsService.store(data, config)
            .then(() => {
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.$refs.form);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },
      async fetchSettings() {
        return settingsService.index()
            .then((response) => {
             this.form = { ...this.form, ...response.data };
            })
            .catch(error => {
              this.handleError(error, this.$refs.form);
            })
            .finally(() => {
              this.loading = false;
            });
      },
    },
    async created() {
      await this.fetchSettings();
    },
  };
</script>

<style scoped>

</style>
